import { render, staticRenderFns } from "./EventCourse.vue?vue&type=template&id=65fc04bb&scoped=true&"
import script from "./EventCourse.vue?vue&type=script&lang=js&"
export * from "./EventCourse.vue?vue&type=script&lang=js&"
import style0 from "./EventCourse.vue?vue&type=style&index=0&id=65fc04bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc04bb",
  null
  
)

export default component.exports